/* global angular */

export default function EditEndnoteDialogController(
  $scope,
  $rootScope,
  alerts,
  loaderService,
  pmSharedModelService,
  ssDialogService,
  materialChangeDialog,
) {
  const vm = this;
  vm.newEndnote = { ...vm.endnote };
  vm.isNew = vm.endnote.tag === '';
  vm.handleClose = _handleClose;
  vm.handleSaveAndClose = _handleSaveAndClose;

  /** **************************************************
   * Event Handlers
   */

  function _handleClose() {
    _closeDialog();
  }

  function _handleSaveAndClose() {
    const isNew = vm.newEndnote.policyDocumentEndNoteId < 0;
    if (isNew || !_isEndNoteChanged(vm.endnote, vm.newEndnote)) {
      _save(isNew)
        .then(() => { _closeDialog(); })
        .catch(e => console.warn(e));
    } else {
      _checkIsMaterialChange(
        (explanation) => {
          _save(isNew, explanation)
            .then(() => { _closeDialog(); })
            .catch(e => console.warn(e));
        }
      );
    }
  }

  /** **************************************************
   * Private Functions
   */

  function _checkIsMaterialChange(callback) {
    ssDialogService.dialogs.pm.materialChangeDialog = ssDialogService.alert(
      materialChangeDialog.getOptions({
        callback
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.materialChangeDialog);
  }

  function _isEndNoteChanged(endnote, newEndnote) {
    return endnote.note !== newEndnote.note;
  }

  function _save(isNew, explanation) {
    if ($scope.pmEditEndnoteForm.$invalid) {
      return Promise.reject(new Error('Invalid form'));
    }

    if (!isNew && angular.equals(vm.endnote, vm.newEndnote)) {
      // No need to save
      return _closeDialog(); // or return Promise.resolve();
    }

    loaderService.showViewLoader = true;
    return pmSharedModelService.saveEndnote(vm.newEndnote, explanation)
      .then((savedEndnote) => {
        angular.extend(vm.newEndnote, savedEndnote);
        angular.extend(vm.endnote, vm.newEndnote);
        if (isNew) {
          $rootScope.$broadcast('pmEndnoteAdded', vm.endnote);
        } else {
          $rootScope.$broadcast('pmEndnoteUpdated', vm.endnote);
        }
        alerts.success('The endnote has been saved successfully.');
      })
      .catch(() => {
        alerts.error('An error occurred while saving the endnote.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.editEndnoteDialog);
  }
}

EditEndnoteDialogController.$inject = [
  '$scope',
  '$rootScope',
  'alerts',
  'loaderService',
  'pmSharedModelService',
  'ssDialogService',
  'materialChangeDialog',
];
